import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent } from "../ui/dialog";

const DIGITAL = new Set(["formation", "guides", "essai"]);
// Décision Ralph (24-09-2026, « pour encore quelques mois ») : tout produit PHYSIQUE de /store s'achète dans l'Espace Membres.
export const isPhysicalProduct = (p) => !p?.is_recurring && !DIGITAL.has((p?.category || "").toLowerCase());

export function MemberStoreBanner() {
  const navigate = useNavigate();
  return (
    <div className="mb-6 rounded-xl border border-[#C9A961]/50 bg-[#C9A961]/10 px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-3" data-testid="member-store-banner">
      <p className="text-sm text-zinc-200 flex-1">
        <b className="text-[#C9A961]">Membres de l'Institut Impact :</b> uniformes, équipements et vêtements officiels s'achètent maintenant dans votre <b>Espace Membres</b> (prix membre, taxes calculées, paiement par carte ou Interac, retrait au dojo).
      </p>
      <button onClick={() => navigate("/membres")} className="shrink-0 px-4 py-2 rounded-lg bg-[#C9A961] hover:bg-[#d8b96e] text-black text-sm font-bold" data-testid="member-store-banner-btn">Aller à mon Espace Membres →</button>
    </div>
  );
}

export function MemberRedirectDialog({ product, onClose }) {
  const navigate = useNavigate();
  return (
    <Dialog open={!!product} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-zinc-950 border-zinc-800 text-zinc-100 max-w-md" data-testid="member-redirect-dialog">
        <div className="text-[10px] uppercase tracking-[0.2em] text-[#C9A961] font-semibold">Kaizen System · Espace Membres</div>
        <h3 className="text-lg font-bold mt-1">{product?.name}</h3>
        <p className="text-sm text-zinc-300 mt-2">
          Les uniformes et équipements se commandent dans <b>votre Espace Membres</b> : connexion sans mot de passe avec votre courriel, panier avec taxes, paiement par carte (Stripe) ou virement Interac, et retrait au dojo (1218, 7<sup>e</sup> Rue, Val-d'Or).
        </p>
        <p className="text-xs text-zinc-500 mt-2">Pas encore membre ? Écrivez-nous à impactkb.bjj@gmail.com ou passez au dojo — nous vous équipons sur place.</p>
        <div className="flex flex-col sm:flex-row gap-2 mt-4">
          <button onClick={() => navigate("/membres")} className="flex-1 px-4 py-2.5 rounded-lg bg-[#C9A961] hover:bg-[#d8b96e] text-black font-bold text-sm" data-testid="member-redirect-go">Aller à mon Espace Membres →</button>
          <button onClick={onClose} className="px-4 py-2.5 rounded-lg bg-zinc-800 hover:bg-zinc-700 text-sm text-zinc-200" data-testid="member-redirect-close">Continuer à regarder</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
